module.exports = __webpack_public_path__ + "img/flourish-coin.fc468575.svg";